export const nameSpace = 'environmentDetector';
export const SUBTITLE_STYLE = { fontSize: '18px' };
